import { useInfiniteQuery } from "hooks/useInfiniteQuery";
import { getSurmountAccountDocuments } from "../service";

export const useSurmountDocuments = ({ enabled = true } = {}) => {
  const {
    data,
    isLoading,
    error,
    fetchNextPage,
    isFetchingNextPage,
    hasNextPage,
    refetch,
  } = useInfiniteQuery({
    queryKey: ["surmountDocuments"],
    queryFn: async ({ pageParam = 1 }) => {
      const params = {
        page: pageParam,
        size: 10,
      };

      const response = await getSurmountAccountDocuments(params);
      return {
        data: response.data,
        currentPage: pageParam,
        totalPages: response?.total_pages,
        totalCount: response?.total_count,
      };
    },
    getNextPageParam: (lastPage) =>
      lastPage.currentPage < lastPage.totalPages
        ? lastPage.currentPage + 1
        : undefined,
    enabled,
  });

  const documents = data?.pages?.flatMap((page) => page.data) || [];
  const latestPage = data?.pages?.[data?.pages.length - 1];
  const totalPages = latestPage?.totalPages || 0;
  const totalCount = latestPage?.totalCount || 0;
  const currentPage = latestPage?.currentPage || 1;
  const loadMore = () => {
    if (hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  };

  return {
    documents,
    isLoading,
    error,
    isFetchingNextPage,
    hasNextPage,
    totalPages,
    totalCount,
    currentPage,
    fetchNextPage: loadMore,
    refetch,
  };
};
